import Countdown from 'react-countdown'

const Completionist = () => {
  return <span>Finsh</span>
}

const rendererSimple = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <Completionist />
  } else {
    return (
      <>
        <div className="js-countdown-single-timer" data-expired="Finsh">
          {days > 0 && (
            <span className="countdown-days text-jacarta-700 dark:text-white pr-1">
              <span className="js-countdown-days-number">{days} days</span>
            </span>
          )}

          {days === 0 && (
            <>
              {hours > 0 && (
                <span className="countdown-hours text-jacarta-700 dark:text-white pr-1">
                  <span className="js-countdown-hours-number">{hours} hour</span>
                </span>
              )}

              {hours === 0 && (
                <>
                  <span className="countdown-minutes text-jacarta-700 dark:text-white pr-1">
                    <span className="js-countdown-minutes-number">{minutes}m</span>
                  </span>

                  <span className="countdown-seconds text-jacarta-700 dark:text-white">
                    <span className="js-countdown-seconds-number">{seconds}s</span>
                  </span>
                </>
              )}
            </>
          )}
        </div>
      </>
    )
  }
}

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <Completionist />
  } else {
    return (
      <>
        <div className="js-countdown-single-timer flex" data-expired="Finsh">
          {days > 0 && (
            <span className="countdown-days text-jacarta-700 dark:text-white pr-1">
              <span className="js-countdown-days-number">{days}d</span>
            </span>
          )}

          {hours > 0 && (
            <span className="countdown-hours text-jacarta-700 dark:text-white pr-1">
              <span className="js-countdown-hours-number">{hours}h</span>
            </span>
          )}

          {minutes > 0 && (
            <span className="countdown-minutes text-jacarta-700 dark:text-white pr-1">
              <span className="js-countdown-minutes-number">{minutes}m</span>
            </span>
          )}

          <span className="countdown-seconds text-jacarta-700 dark:text-white">
            <span className="js-countdown-seconds-number">{seconds}s</span>
          </span>
        </div>
      </>
    )
  }
}

const StakingItemCountDown = ({ time, simple }) => {
  return <Countdown date={Date.now() + time} renderer={simple ? rendererSimple : renderer}></Countdown>
}

export default StakingItemCountDown
